import "./styles.scss";

import { API, Endpoints } from "utils/api";
import { Col, Input, Row, notification } from "antd";
import { setBreadcrumb, setLoader } from "store/actions";

import { Footer } from "screens";
import { Helmet } from "react-helmet";
import React from "react";
import Strings from "utils/strings";
import { connect } from "react-redux";

class ContactUs extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			subject: "",
			message: ""
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		dispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.sidebar.contactUs,
						route: "/contact-us"
					}
				]
			}))
		);
	}

	async submitContact() {
		const { subject, description } = this.state;
		const { dispatch } = this.props;

		if (!subject?.trim() || !description?.trim()) {
			return notification.warn({
				message: Strings.sidebar.contactUs,
				description: Strings.errors.invalidFields,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriSupport(),
				data: {
					subject,
					message: description
				}
			});

			if (response.ok) {
				this.setState({ subject: "", description: "" });

				notification.success({
					message: Strings.sidebar.contactUs,
					description: Strings.profile.contactSent,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.sidebar.contactUs,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.contactUs,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	render() {
		const { subject, description } = this.state;
		const { mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.contactUs} | Team24</title>
					<meta name="description" content="Description of Contact Us" />
				</Helmet>
				<div className="ContactUsContent">
					<h1 className="GenericTitle">{Strings.sidebar.contactUs}</h1>
					<div className="ContactUsDivision">
						<form
							onSubmit={(e: any) => {
								e.preventDefault();
								this.submitContact();
							}}
							className="ContactUsForm"
						>
							<h2>{Strings.contactUs.haveQuestions}</h2>
							<p>{Strings.contactUs.sendUsMessage}</p>
							<Row gutter={[0, 20]}>
								<Col xs={24}>
									<label htmlFor="form_subject" className="InputLabel --label-required">
										{Strings.contactUs.subject}
									</label>
									<Input
										id="form_subject"
										value={subject || ""}
										className="ProfileInput"
										required
										placeholder={Strings.contactUs.subject}
										onChange={(e: any) => {
											this.setState({
												subject: e.target.value
											});
										}}
									/>
								</Col>
								<Col xs={24}>
									<label htmlFor="form_subject" className="InputLabel --label-required">
										{Strings.contactUs.description}
									</label>
									<Input.TextArea
										id="form_subject"
										value={description || ""}
										className="ProfileInput"
										required
										rows={10}
										placeholder={Strings.placeholders.description}
										onChange={(e: any) => {
											this.setState({
												description: e.target.value
											});
										}}
									/>
								</Col>
							</Row>
							<button type="submit">{Strings.contactUs.send}</button>
						</form>
						<div className="ContactUsIllustration" />
					</div>
				</div>
				{mobile && <Footer />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	business: state.business,
	user: state.user,
	language: state.language,
	mobile: state.mobile
});

export default connect(mapStateToProps)(ContactUs);
